


import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setEmpBlockGetlistEmpEmpAction } from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import _, { values } from "lodash";
import approved from "../../../Assets/MainComponent/approved.svg";
import declined from "../../../Assets/MainComponent/decline.svg";
import pending from "../../../Assets/MainComponent/pending.svg";
import HeadingComp from "./UdsEmployeeDashboard/CustomHooks/HeadingComp";
import data from "../../../Json/Language/English";
import hindiDatas from "../../../Json/Language/Hinid";
import useLanguageSelector from "./UdsEmployeeDashboard/CustomHooks/useLanguageSelector";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import BlockEmployeePopupEmp from "./BlockEmployeePopupEmp";

export const BlockEmployeeEmp = () => {
    const state = useSelector((state) => state)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const EnglishData = data;
    const HindiData = hindiDatas;
    const hindiApplyLeave = HindiData;
    const [sno, setsno] = useState(0);

    const [createEditPopup, setCreateEditPopup] = useState(false);
    const [editPayload, setEditPayload] = useState({});
    const [dtpageindex, setdtPageindex] = useState(1);
    const [dtpagesize, setdtPagesize] = useState(10);
    const FileterState = {
        status: ""
    }
    const [selectVal, SetSelectval] = useState(FileterState);
    const [OptionValues, setOptionvalues] = useState([{ value: "", label: "All" }])

    const options = [
        { value: "", label: "All" },
        { value: "pending", label: "Pending" },
        { value: "decline", label: "Rejected" },
        { value: "approved", label: "Approved" },
    ];
    const [search, setsearch] = useState("")

    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive
    );

    useEffect(() => {
         if(createEditPopup == false){ 
        const payload = {
            page_size: 10,
            page: dtpageindex,
            status: selectVal.status,
            search: search,
            type: true,
            Popup: 0,
        };
        dispatch(setEmpBlockGetlistEmpEmpAction(payload));
    }
    }, [selectVal, dtpageindex, search , createEditPopup]);

    console.log(state.EmpBlockEmpDatagetStored.EmpBlockDataStoreDtaas, "asdasd EmpBlockEmpDatagetStored");

    const capitalizeFirstLetter = (Letter) => {
        return Letter.charAt(0).toUpperCase() + Letter.slice(1);
    };
    const handleNext = (next) => {
        setdtPageindex(next + 1);
    };

    const GotoEnteredPage = (gotopage) => {
        setdtPageindex(gotopage)
    }

    const handlePrevious = (previous) => {
        if (previous != 0) {
            setdtPageindex(previous);
        }
    };
    const pagesize = (arg) => {
        setdtPagesize(arg);
    };

    const pageindex = (arg) => {
        setdtPageindex(arg);
    };
    const columns = useMemo(
        () => [
            {
                Header: "S.NO",
                accessor: "",
                Cell: (row) => {
                    console.log(row.row);
                    console.log(sno);
                    return <p>{Number(sno + row.row.index + 1)}</p>;
                },
            },


            {
                Header: "Employee Name",
                accessor: "",
                Cell: (row) => {
                    return (
                        <>
                            {row.row.original.user_id.first_name ? (
                                <span>{row.row.original.user_id.first_name}</span>
                            ) : (
                                <span>---</span>
                            )}
                        </>
                    );
                },
            },
            {
                Header: "Created date",
                accessor: "",
                Cell: (row) => {
                    const dateString = row.row.original.created_at;
                    const dateObject = new Date(dateString);
                    const hours = dateObject.getHours();
                    const minutes = dateObject.getMinutes();
                    const seconds = dateObject.getSeconds();
                    const amOrPm = hours >= 12 ? "PM" : "AM";
                    const twelveHourFormat = hours % 12 || 12;

                    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

                    const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
                    return (
                        <>
                            <p
                            >
                                {`${row.row.original.created_at.slice(0, 10) +
                                    "  " +
                                    formattedTime
                                    }`}
                            </p>
                        </>
                    );
                },
            },

            {
                Header: "Reason",
                accessor: "",
                Cell: (row) => {
                    return (
                        <>
                            {row.row.original.reason ? (
                                <span>{row.row.original.reason}</span>
                            ) : (
                                <span>---</span>
                            )}
                        </>
                    );
                },
            },

            {
                Header: "Status",
                accessor: "",
                Cell: (row) => {
                    const originalString = row.row.original.status;
                    const capitalizedString = capitalizeFirstLetter(originalString);

                    return (
                        <>
                            {row.row.original.status != undefined ? (
                                <>
                                    <img
                                        src={
                                            row.row.original.status == "approved"
                                                ? approved
                                                : row.row.original.status === "pending"
                                                    ? pending
                                                    : declined
                                        }
                                        alt="img"
                                        width={"25px"}
                                        height={"25px"}
                                    />
                                    &nbsp;
                                    <span>
                                        {row.row.original.status == "approved"
                                            ? "Approved"
                                            : row.row.original.status === "pending"
                                                ? "Pending"
                                                : "Decline"}
                                    </span>
                                </>
                            ) : (

                                <span>{"--"}</span>
                            )}
                        </>
                    );
                },
            },
        ].filter(Boolean), [sno]
    );


    const ClearState = (counts) => {
        setOptionvalues({ value: "", label: "All" })
        SetSelectval({
            ...selectVal,
            status: "",

        });
    };

    const count = (Counts, values, sel, SelectedValues) => {
        setOptionvalues(SelectedValues)
        SetSelectval({
            ///Completed
            ...selectVal,
            status: SelectedValues.value
        });
    };

    // -----Search------------------------
    function tochange(e) {
        setdtPageindex(1);
        debouncedSearch(e);

    }
    const debouncedSearch = useMemo(
        () =>
            _.debounce((e) => {
                setsearch(e);
            }, 500),
        []
    );
    React.useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);


    return (
        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>
                <div className="leaveWrapper">

                    <div className="row ButtonPrevious Filters"
                        style={{
                            padding: "4px 4px",
                            margin: "0px",
                            position: "relative",
                            zIndex: "30",
                            marginLeft: "0px",
                            marginRight: "0px",
                        }}>
                        <div className="col-12 leaveHeading text-left">
                            <h3>BLOCK EMPLOYEE</h3>
                        </div>

                        <div className="col">
                            <button
                                className="btn BackImga"
                                onClick={(e) => {
                                    navigate("/teamemp");
                                }}
                            >
                                <img className="PreviousPages" src={BackImage} />
                                <span></span>

                            </button>
                        </div>
                        <div className="col leaveButton">
                            <button
                                className="customButton  ButtonCSS"
                                onClick={() => {
                                    setCreateEditPopup(true);
                                }}
                                style={{ marginBottom: "20px", background: "#234492", color: "white" }}
                            >
                                {useLanguageSelector(
                                    EnglishData.BlockEmployeelan.applyButton,
                                    HindiData.BlockEmployeelan.applyButton
                                )}

                            </button>
                        </div>
                    </div>


                    <div className="col-12 leaveSubHeading">


                        <ReactTable
                            data={state.EmpBlockEmpDatagetStored.EmpBlockDataStoreDtaas}
                            datacount={state.EmpBlockEmpDatagetStored.Total_Count}
                            columns={columns}
                            pagesize={pagesize}
                            dtpagesize={20}
                            dtpageindex={dtpageindex}
                            pageindex={pageindex}
                            Search={false}
                            onPrevious={handlePrevious}
                            onNextpage={handleNext}
                            GotoEnteredPage={GotoEnteredPage}
                            Filter={true}
                            values={OptionValues}
                            options={options}
                            count={count}
                            ClearState={ClearState}
                            onChange={tochange}

                            setsno={setsno}
                            sno={sno}
                            id={"spe"}
                        />

                    </div>
                </div>
            </div>

            {createEditPopup == true && (<BlockEmployeePopupEmp

                show={createEditPopup}
                setShow={setCreateEditPopup}
                editPayload={editPayload}
                setEditPayload={setEditPayload}
                PageIndex={dtpageindex}
                search={search} />
            )}

        </>


    )
}
